import React, { PropsWithChildren } from 'react'
import { ActionModule } from '@typesApp/ActionModule'
import { HostEnvironment, HostSession } from '@typesApp/Environment'
import { WidgetContextHolder } from '@typesApp/WidgetContextHolder'
import { WidgetContext } from '@components/widgetContext/context'
import { useAppInit } from './useAppInit'

export type AppProps = PropsWithChildren & {
  session: HostSession
  environment: HostEnvironment
  actionModule: ActionModule
  widgetContext?: WidgetContextHolder
}

export const AppHOC: React.FC<AppProps> = props => {
  const { session, environment, actionModule, widgetContext } = props
  useAppInit({ session, environment, actionModule })

  return <WidgetContext.Provider value={widgetContext ?? {}}>{props.children}</WidgetContext.Provider>
}
